import './App.css'

import { TicTacToe } from './features/tictactoe'

function App() {
  return (
    <div className="App">
      <TicTacToe />
    </div>
  )
}

export default App
